import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { gridClasses } from "@mui/x-data-grid-premium";
import { t } from "i18next";
import { secondary } from "../../../theme/colors";
import { DynamicDataGrid } from "./dynamicDataGrid";
import useDynamicCatalog from "./useDynamicCatalog";
import { tablePaginationClasses } from "@mui/material";
export var DynamicCatalogBuilder = function (props) {
    var _a;
    var _b = props.columns, columns = _b === void 0 ? [] : _b, pageSizeOptions = props.pageSizeOptions, dataGridProps = props.dataGridProps;
    var _c = useDynamicCatalog(props), rows = _c.rows, paging = _c.paging, count = _c.count, loading = _c.loading, onPageSizeChange = _c.onPageSizeChange, onSortChange = _c.onSortChange, onFilterModelChange = _c.onFilterModelChange;
    return /*#__PURE__*/ React.createElement(DynamicDataGrid, _extends({
        paginationMode: "server",
        pageSize: paging === null || paging === void 0 ? void 0 : paging.take,
        onPaginationModelChange: onPageSizeChange,
        rows: rows !== null && rows !== void 0 ? rows : [],
        columns: columns,
        rowCount: count,
        loading: loading,
        onSortModelChange: onSortChange,
        onFilterModelChange: (dataGridProps === null || dataGridProps === void 0 ? void 0 : dataGridProps.filterMode) === 'client' ? undefined : onFilterModelChange,
        pageSizeOptions: pageSizeOptions,
        filterDebounceMs: 500,
        rowHeight: 68,
        columnHeaderHeight: 64,
        disableColumnFilter: true,
        disableRowGrouping: true,
        showColumnVerticalBorder: true,
        localeText: {
            noResultsOverlayLabel: t('No records found'),
            noRowsLabel: t('No records found')
        }
    }, dataGridProps, {
        initialState: _objectSpread({
            density: 'compact'
        }, dataGridProps === null || dataGridProps === void 0 ? void 0 : dataGridProps.initialState),
        slotProps: _objectSpread({
            loadingOverlay: {
                variant: 'skeleton',
                noRowsVariant: 'skeleton'
            }
        }, dataGridProps === null || dataGridProps === void 0 ? void 0 : dataGridProps.slotProps),
        sx: _objectSpread((_a = {
                "--DataGrid-containerBackground": secondary[50],
                fontSize: 'sm',
                background: 'white',
                borderRadius: '2xl'
            },
            _a["& .".concat(gridClasses.virtualScroller)] = {
                maxHeight: '45svh',
                height: 'min-content',
                minHeight: 150
            },
            _a["& .".concat(gridClasses.iconSeparator)] = {
                height: 30,
                width: 30
            },
            _a["& .".concat(tablePaginationClasses.displayedRows, ", .").concat(tablePaginationClasses.selectLabel)] = {
                fontSize: 'base'
            },
            _a), dataGridProps === null || dataGridProps === void 0 ? void 0 : dataGridProps.sx)
    }));
};
